import { createElement, waitFor } from './globalFunctions'
/**
 * Moves `flags-extra` element inside `flags-default` element and adds the `contains-extra` class to the `flags-default` element.
 * @param {*} product Product card element
 */




/**
 * Creates numeric ratings from the stars value.
 * @param {*} product Product card element
 * @param {*} whereToAppend Element where the ratings should be appended
 */
const createNumericRagings = (product, whereToAppend = false) => {
	if (product.hasAttribute('data-ratings-created')) return
	const ratingsValue = product.querySelector('.stars-wrapper')
	if (!ratingsValue) return
	const productImage = whereToAppend || product.querySelector('.image')
	const customRatings = document.createElement('div')
	customRatings.classList.add('custom-ratings', 'stars')
	customRatings.innerHTML = `
			${ratingsValue.getAttribute('data-micro-rating-value') || 0} <span class="star star-on"></span> 
		`
	productImage.appendChild(customRatings)
	product.setAttribute('data-ratings-created', '')
}

/**
 * Moves the `dkLabFavouriteProductDiv` element inside the `whereToAppend` element.
 * @param {*} product Product card element
 * @param {*} whereToAppend Element where the `dkLabFavouriteProductDiv` should be appended
 */
const moveAddToFavorites = (product, whereToAppend) => {
	if (product.hasAttribute('data-favoriteModified')) return
	waitFor('.dkLabFavouriteProductDiv').then(() => {
		const addToFavoritesWrap = product.querySelector('.dkLabFavouriteProductDiv')
		if (!addToFavoritesWrap || !whereToAppend) return
		product.setAttribute('data-favoriteModified', 'true')
		if (window.innerWidth > 767) {
			whereToAppend.appendChild(addToFavoritesWrap)
		} else {
			const pTools = product.querySelector('.p-tools')
			if (pTools) {
				pTools.prepend(addToFavoritesWrap)
				pTools.classList.add('has-favorite')
			}
		}
	})
}



const handleDetailBtn = (product) => {
	const detailBtn = product.querySelector('.p-tools a.btn')
	if (detailBtn) {
		detailBtn.textContent = window.language === 'cs' ? 'Zobrazit detail' : 'Zobraziť detail'
	} else {
		if (product.querySelector('.p-extra-wrapper')) return
		const btnWrapper = createElement('div', ['p-extra-wrapper'])
		const addedDetailBtn = createElement('a', ['btn', 'btn-primary'], window.language === 'cs' ? 'Zobrazit detail' : 'Zobraziť detail')
		const pInIn = product.querySelector('.p-in-in')
		const name = product.querySelector('.name')
		if (name) addedDetailBtn.href = name.href
		if (!pInIn) return
		btnWrapper.appendChild(addedDetailBtn)
		pInIn.appendChild(btnWrapper)
	}
}

// takes existing input amount and adds increase and decrease buttons
// this allows user to change the amount while adding to cart outside of its product detail page
// NOTE: the quantity input has to stay in the form with the add to cart button, otherwise it will not work
//also moves availability to the bottom of the product card
const handleBtnInput = (product) => {
	const inputAmount = product.querySelector('.p-tools input[name="amount"]')
	// const btnWrapper = product.querySelector('.p-extra-wrapper')
	const form = product.querySelector('.p-tools form')
	const pBottom = product.querySelector('.p-bottom')
	const availability = product.querySelector('.availability')
	if (!inputAmount || product.querySelector('.p-tools form .quantity')) return

	inputAmount.setAttribute('type', 'number')
	if (inputAmount.value > 1) inputAmount.setAttribute('min', inputAmount.value)
	else inputAmount.setAttribute('min', 1)

	inputAmount.setAttribute('max', 9999)
	inputAmount.setAttribute('aria-label', window.language === 'cs' ? 'Množství' : 'Množstvo')

	inputAmount.classList.add('amount')
	const quantity = createElement('span', ['quantity'])
	const increase = createElement('button', ['increase'])
	const decrease = createElement('button', ['decrease'])
	const increaseSpan = createElement('span', ['increase__sign'])
	const decreaseSpan = createElement('span', ['decrease__sign'])
	increase.setAttribute('role', 'button')
	decrease.setAttribute('role', 'button')
	increase.setAttribute('aria-label', window.language === 'cs' ? 'Zvýšit množství' : 'Zvýšiť množstvo')
	decrease.setAttribute('aria-label', window.language === 'cs' ? 'Snížit množství' : 'Znížiť množstvo')
	// increase.addEventListener('click', () => {
	// 	console.log(inputAmount.value)

	// 	inputAmount.value = parseInt(inputAmount.value) + 1
	// 	console.log('increase')
	// 	console.log(inputAmount.value)
	// })
	// decrease.addEventListener('click', () => {
	// 	if (parseInt(inputAmount.value) > 1) {
	// 		inputAmount.value = parseInt(inputAmount.value) - 1
	// 	}
	// })
	increase.appendChild(increaseSpan)
	decrease.appendChild(decreaseSpan)
	quantity.appendChild(inputAmount)
	quantity.appendChild(increase)
	quantity.appendChild(decrease)
	if (form) {
		form.prepend(quantity)
		if (availability) form.prepend(availability)
	}

	if (pBottom) pBottom.classList.add('has-quantity')
	// if (ratingsWrapper) ratingsWrapper.appendChild(quantity)
	// if (btnWrapper) {
	// 	btnWrapper.appendChild(quantity)
	// } else {
	// 	const newBtnWrapper = createElement('div', ['p-extra-wrapper'])
	// 	newBtnWrapper.appendChild(quantity)
	// 	product.querySelector('.p-in-in').appendChild(newBtnWrapper)
	// }
}




const setColorOnAvailability = (product) => {
	const availabilitySpan = product.querySelector('.availability span')
	if (!availabilitySpan || !availabilitySpan.hasAttribute('style')) return
	const availability = product.querySelector('.availability')
	if (!availability) return
	availability.setAttribute('style', availabilitySpan.getAttribute('style'))
}
const priceStandardToPrices = () =>{
	const productsBlock = document.querySelectorAll('.products-block');
	if (!productsBlock) return;
	productsBlock.forEach((productsBlock) => {
		const product = productsBlock.querySelectorAll('.product');
		if (!product) return;
		product.forEach((item) => {
			const pPrice = item.querySelector('.prices');
			if (!pPrice) return;
			const pStandard = item.querySelector('.price-standard');
			if (!pStandard) return;
			pPrice.appendChild(pStandard);
		})
	})
}
const couponAction = () => {
    const productsBlock = document.querySelectorAll('.products-block');
    if (!productsBlock) return;
    productsBlock.forEach((productsBlock) => {
        const products = productsBlock.querySelectorAll('.product');
        products.forEach((item) => {
			const pIn = item.querySelector('.p-in');
			if (!pIn) return;
            const offerDiv = item.querySelector('div[data-micro="offer"]');
            const couponFlag = item.querySelector('.flag.flag-coupon');
            if (!offerDiv || !couponFlag) return;
            const price = offerDiv.getAttribute('data-micro-price');
            if (!price) return;
             
            const couponText = couponFlag.textContent.trim();
            let cuponCode = '';
            let discountValue = '';
            const match = couponText.match(/^([^#]+)#([^#]+)#/);
            if (match) {
                cuponCode = match[1];
                discountValue = match[2];
            } else {
                return; 
            }

            const calculatedPrice = (parseFloat(price) * (100 - parseFloat(discountValue))) / 100;
            const couponWrapper = document.createElement('div');
            couponWrapper.classList.add("coupon-wrapper");
            couponWrapper.innerHTML = `Vaše cena <span class="coupon-price">${calculatedPrice.ShoptetFormatAsCurrency()}</span> s kódom <span class="coupon-text">${cuponCode}</span> `;
            pIn.appendChild(couponWrapper);
        });
    });
}
export {

	createNumericRagings,
	moveAddToFavorites,
	handleDetailBtn,
	handleBtnInput,
	setColorOnAvailability,
	priceStandardToPrices,
couponAction
}
